import { Action } from "@ngrx/store";

export enum EPaymentActions {
    PaymentResult = "[Payment] Payment Result"
}

export class PaymentResultAction implements Action {
    public readonly type = EPaymentActions.PaymentResult;
}

export type PaymentsActions = PaymentResultAction;
